import { connect } from 'react-redux';

import { splitTestSelectors } from 'wanderu-ducks-split-test';

import SplitTest from './SplitTest';

export function mapStateToProps(state, ownProps) {
    const {
        testName,
    } = ownProps;

    return {
        cachedExperimentGroup: splitTestSelectors.selectCachedTestVariant(state, testName),
        eventData: splitTestSelectors.selectSnowplowTestRenderedEventData(state, testName),
        experimentGroup: splitTestSelectors.selectTestVariant(state, testName),
    };
}

const ConnectedSplitTestComponent = connect(mapStateToProps)(SplitTest);

export default ConnectedSplitTestComponent;
